<template>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div class="report">

        <div id="element-to-convert">

          <img src="@/assets/images/bgreport.jpg" class="bg-report" />
          <div class="content-report">

          <div class="header-report">
            <div class="title">
              Personal<br />
              Eyewear Report
            </div>
            <div class="infos">
              <div class="line-info">
                <div class="label">
                  DATE
                </div>
                <div class="value">
                  {{ order.date }}
                </div>
              </div>
              <div class="line-info">
                <div class="label">
                  ORDER
                </div>
                <div class="value">
                  #{{ order.id }}
                </div>
              </div>

              <div class="line-info">
                <div class="label">
                  CUSTOMER
                </div>
                <div class="value">
                  {{ scan.name }}
                </div>
              </div>
              
            </div>
          </div>

          <div class="table-product">
              <div class="photo-product">
                <div class="image product-img" v-if="b64image">

                                
                  <img :src='b64image'

                  />
                  </div>
              </div>
              <div class="product-infos">
                <div class="col-info">
                  <div class="title-content">
                    Product
                  </div>
                  <div class="content-value"> 
                    <span v-if="order_item.product_variation_item">
                      {{order_item.glass.name}} ({{order_item.product_variation_item.name}})
                    </span>
                    <span v-else>
                      {{order_item.glass.name}}
                    </span>
                  </div>
                </div>
                <!--<div class="col-info">
                  <div class="title-content">
                    Quantity
                  </div>
                  <div class="content-value">
                    {{order_item.quantity}}
                  </div>
                </div>
-->
                <template v-for="order_item_customization in order_item.order_item_customizations">
                 <div class="col-info" v-if="order_item_customization.model_part.type=='color' && order_item_customization.model_part.render_type=='face'">
                  <div class="title-content">
                      Color
                    </div>
                    <div class="content-value">
                    
                      {{order_item_customization.color.name}}
                    </div>
                  </div>
                  <template v-else-if="order_item_customization.model_part.type=='texture_color' && order_item_customization.model_part.render_type=='face'">

                    <div class="col-info">
                      <div class="title-content">
                        Color
                      </div>
                      <div class="content-value">
                        {{order_item_customization.color.name}}
                      </div>
                    </div>
                    <div class="col-info">
                      <div class="title-content">
                        Texture
                      </div>
                      <div class="content-value">
                        {{order_item_customization.texture.name}} <span v-if="order_item_customization.texture_style && order_item_customization.texture.id!=4">({{order_item_customization.texture_style.name}})</span>
                      </div>
                    </div>
                  </template>
                
                </template>
                <template v-for="order_item_customization in order_item.order_item_customizations">
                  <div class="col-info" v-if="order_item_customization.model_part.type=='color' && order_item_customization.model_part.render_type=='branch'">
                    <div class="title-content">{{order_item_customization.model_part.name}}</div>
                    <div class="content-value">{{order_item_customization.color.name}}</div>
                  </div>
                  <template v-else-if="order_item_customization.model_part.type=='texture_color' && order_item_customization.model_part.render_type=='branch'">

                    <div class="col-info">
                      <div class="title-content">{{order_item_customization.model_part.name}}</div>
                      <div class="content-value"> {{order_item_customization.color.name}}</div>
                    </div>
                   

                   
                  
                  </template>
                <!-- <span v-if="order_item_customization.model_part.render_type=='lense'">Teinte de verres : {{order_item_customization.tint ? order_item_customization.tint.name : "Aucune"}}<br /></span> -->
                </template>

               
                <div class="col-info">
                  <div class="title-content">
                    Lenses
                  </div>
                  <div class="content-value">
                    {{order_item.tint.name}}
                  </div>
                </div>

                <div class="col-info" v-if="order_item.engraving!=null && order_item.engraving!=''">
                  <div class="title-content">
                    Engraving
                  </div>
                  <div class="content-value">
                    {{order_item.engraving}}
                  </div>
                </div>

                <template v-if="order_item.scan && !order_item.size">

                  <div class="col-info">
                    <div class="title-content">
                      Custom Fit 
                    </div>
                    <div class="content-value">
                      {{order_item.scan.name}})
                    </div>
                  </div>
                </template>
                <template v-else>

                  <div class="col-info">
                    <div class="title-content">
                      Size
                    </div>
                    <div class="content-value">
                      {{order_item.size.toUpperCase()}}
                    </div>
                  </div>
                  </template>
            
              </div>
            </div>

            <div class="scans-canvas"  >
              <div class="scan-canvas-content">
                <div class="head-scan">
                  <div class="left">
                    <span class="legend">3D: FACE</span>
                  </div>
                  <div class="mid">
                    <span class="legend">3D: 3/4</span>
                  </div>
                  <div class="right">
                    <span class="legend">3D: SIDE</span>
                  </div>
                </div>
                <scan-canvas v-if="scan" :scan="scan" />
              </div>
            </div>

            <div class="scan-measures" v-if="measurements">

              <div class="left">
           
          
                <div class="subtitle">Morphological Related Measurements</div>
                <br />
                  <div class="measure-line">
                    <span class="label">Cantus Distance:</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.CantusDistance}}</span>
                  </div>
                
                  
                  
                  <div class="measure-line">
                    <span class="label">Sphenoidal Width :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.SpenoidalWidth}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Temple To Temple Width:</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.TempleDistance}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Eyebrow Height :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.EyeBrowHeight}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Cheekbone Height :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.CheekboneHeight}}</span>
                  </div>
                  <br />
                  <div class="subtitle">Nasal Measurements</div>
                  <br />
                 
                  
                  <div class="measure-line">
                    <span class="label">Right Nasal Face Angle :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.RightNasalFaceAngle}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Left Nasal Face Angle :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.LeftNasalFaceAngle}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Right Nasal Caster Angle :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.RightNasalCasterAngle}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Left Nasal Caster Angle :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.LeftNasalCasterAngle}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Nose Crete Angle :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.NoseCreteAngle}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Nasal Bone Width :</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.NasalWidth}}</span>
                  </div>
                  <div class="measure-line">
                    <span class="label">Eye to lens distance (Topological):</span>
                    <span class="dots"></span>
                    <span class="value">{{ measurements.EyeToLensDistance}}</span>
                  </div>
              </div>
              <div class="right">
            
                <div class="subtitle">Fit Measurements</div>
                <br />
                
                <div class="measure-line">
                  <span class="label">Close Pupillary Distance:</span>
                  <span class="dots"></span>
                  <span class="value">{{ measurements.PupillaryDistance.toFixed(3)}}</span>
                </div>
                <div class="measure-line">
                  <span class="label">Far Pupillary Distance:</span>
                  <span class="dots"></span>
                  <span class="value">{{ (measurements.PupillaryDistance*1+4*1).toFixed(3)}}</span>
                </div>
                <div class="measure-line">
                  <span class="label">Eye to lens distance:</span>
                  <span class="dots"></span>
                  <span class="value">{{ eye_to_lens_distance}}</span>
                </div>
                <div class="measure-line">
                  <span class="label">Pupillary height:</span>
                  <span class="dots"></span>
                  <span class="value">{{ pupillary_height}}</span>
                </div>
            
      <!-- 
                Auricular Width : {{ measurements.AuricularWidth}} <br />
                
                
                
                
                
                  
                
                
                Nasal height : {{ measurements.NasalHeight}}<br />
                
                
                
                
                
                
                
                Unprojected auricular width :  {{ measurements.UnprojectedAuricularWidth }} -->
            
                </div>
             </div>

             <div class="subtitle trait">Lens centering</div>
         <br /> 
             <div class="lens-centering">
              <div class="left">
                Right lens.................................................
              </div>
              <div class="center"  :style="{width:calculateSize()}">
                <img ref="lensCenteringImage" :src="lensCenteringImageData || 'https://rhino.visages.com:8082/frames/custom-fit/client-'+order_item.scan.id+'-model-'+calculateModelName(order_item.glass.id)+'-size-'+order_item.size.toUpperCase()+'-frame_drop-lenses.svg'" @load="convertLensImageToBase64" />
              </div>
              <div class="right">
                <div class="title">.................................................Left lens</div>
              </div>
             </div>

             <div class="report-footer">
                <div>
                  Visages
                </div>
                <div>
                  2026
                </div>
                <div>Personal Eyewear Report</div>
                <div>
                  <img src="@/assets/images/logo2.png" width="150" />
                </div>
              </div>
            </div>
          </div>
       
      
        <br />  <br /> 
      
  <center>
  <b-button @click="generateReport()"
    
    
  >
    Download PDF
  </b-button>
  </center> <br />  <br /> 
     
    
      </div>
    </b-overlay>
  </template>
  
  <script>
  
  import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'
  import { VueGoodTable } from 'vue-good-table'
  import ScanPopup from '../../components/ScanPopup.vue'
  import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import emitter from 'tiny-emitter/instance'
  import ScanCanvas from './ScanCanvas.vue'
  import CartImage from "./CartImageComponentB64.vue";
  import html2pdf from "html2pdf.js";
  
  export default {
    components: {
      BCard,
      BCardText,
      VueGoodTable,
      BAvatar,
      BOverlay,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      BModal,
      BButton,
      BRow,
      ScanPopup,
      PrescriptionPopup,
      ScanCanvas,
      CartImage
    },
    data() {
      return {
        ids:[37,22,29,30,25,26,27,28,58,35,34,24,36,41,42,43,44,45,46,47,48],
        scan:null,
        svgWidth:0,
        selectedScan:localStorage.senseye_b2b_selected_scan,
        loading:true,
        displayMeasurements:true,
        measurements:null,
        b64image:null,
        lensCenteringImageData:null
      }
    },

    props:['scan_id','order_item','order','pupillary_height','eye_to_lens_distance'],
    
    methods:{
      async getUrl(){

        if(this.ids.includes(this.order_item.glass.id))
        {
            var url = 'api/photo-single-b64?glass='+this.order_item.glass.id
        }
        else
        {
            var url = 'api/photo-single-new-b64?glass='+this.order_item.glass.id
        }

        var has_lenses=false;
        console.log('TEST URL')
        console.log(this.order_item)

        for(let i=0;i<this.order_item.order_item_customizations.length;i++)
        {
            if(this.order_item.order_item_customizations[i].model_part.type=='color' || this.order_item.order_item_customizations[i].model_part.type=='texture_color')
            {
                if(this.order_item.order_item_customizations[i].model_part.render_type=='branch')
                {
                    url+='&branch_color='+this.order_item.order_item_customizations[i].color.id
                }
                else
                {
                    url+='&color='+this.order_item.order_item_customizations[i].color.id
                }

                if(this.order_item.order_item_customizations[i].model_part.type=='texture_color')
                {
                    if(this.order_item.order_item_customizations[i].texture)
                    {
                        url+='&texture='+this.order_item.order_item_customizations[i].texture.id
                    }
                    else
                    {
                        url+='&texture=4'
                    } 

                    if(this.order_item.order_item_customizations[i].texture_style)
                    {
                        url+='&texture_style='+this.order_item.order_item_customizations[i].texture_style.id
                    }
                    else
                    {
                        url+='&texture_style=0'
                    }
                }
              
                
            }
            else if(this.order_item.order_item_customizations[i].model_part.type=='lense')
            {
                has_lenses=true;
                url+='&tint='+this.order_item.order_item_customizations[i].tint.id
            }


        }

        if(has_lenses==false)
        {
            if(this.order_item.tint)
            {
                url+='&tint='+this.order_item.tint.id
            }
            else
            {
                url+='&tint=5'
            }
        }

        let response=await APIRequest.get_request(url)
        
     
        return response.data.image_base64;


        },
      calculateModelName(id)
      {
        if(id==58) return 'Louis%20C'
        if(id==35) return 'Genera%207'
        if(id==45) return 'Gabriel'
        return 'Louis%20C'
      },
      convertLensImageToBase64() {
        console.log('convertLensImageToBase64');
        if (!this.lensCenteringImageData && this.$refs.lensCenteringImage) {
          const img = this.$refs.lensCenteringImage;
          
          // Check if image is already a data URL
          if (img.src && img.src.startsWith('data:')) {
            this.lensCenteringImageData = img.src;
            return;
          }
          
          // Try blob fetch first (before canvas, to avoid tainted canvas issue)
          // This might work even if canvas doesn't, if server allows CORS for fetch
          this.fetchImageAsBlob(img.src).catch(() => {
            // If blob fetch fails, try canvas method with crossOrigin set
            console.log('Blob fetch failed, trying canvas method');
            this.convertImageToCanvas(img);
          });
        }
      },
      
      async fetchImageAsBlob(imageUrl) {
        // Try to fetch the image as a blob and convert to data URL
        // This requires the server to send proper CORS headers
        return fetch(imageUrl, { 
          mode: 'cors',
          credentials: 'omit'
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.startsWith('image/')) {
              throw new Error('Response is not an image');
            }
            return response.blob();
          })
          .then(blob => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                this.lensCenteringImageData = reader.result;
                resolve(reader.result);
              };
              reader.onerror = () => {
                reject(new Error('FileReader failed to read blob'));
              };
              reader.readAsDataURL(blob);
            });
          });
      },
      
      convertImageToCanvas(img) {
        console.log('convertImageToCanvas');
        // Ensure image is loaded
        if (!img.complete || img.naturalWidth === 0) {
          console.warn('Image not fully loaded yet, waiting...');
          // Wait for image to load
          const checkLoad = () => {
            if (img.complete && img.naturalWidth > 0) {
              this.convertImageToCanvas(img);
            } else {
              setTimeout(checkLoad, 100);
            }
          };
          checkLoad();
          return;
        }
        
        // Create a new image with crossOrigin set to avoid tainted canvas
        const newImg = new Image();
        newImg.crossOrigin = 'anonymous';
        
        newImg.onload = () => {
          const canvas = document.createElement('canvas');
          const width = newImg.naturalWidth || newImg.width || 800;
          const height = newImg.naturalHeight || newImg.height || 600;
          
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          
          try {
            // Draw the image to canvas
            ctx.drawImage(newImg, 0, 0, width, height);
            
            // Convert to base64 PNG (like ScanCanvas does)
            const base64 = canvas.toDataURL('image/png');
            this.lensCenteringImageData = base64;
            console.log('Successfully converted image to base64 via canvas');
          } catch (error) {
            // Still CORS error - canvas cannot export cross-origin images
            console.warn('Canvas conversion still blocked by CORS:', error.message);
            console.warn('Image will rely on html2canvas to capture it');
            // Don't set lensCenteringImageData - let html2canvas handle the original image
          }
        };
        
        newImg.onerror = () => {
          console.warn('Failed to load image with crossOrigin, will rely on html2canvas');
        };
        
        // Set src after setting crossOrigin
        newImg.src = img.src;
      },
      
      generateReport () {
        // Generate PDF - image is already converted to base64
        html2pdf(document.getElementById("element-to-convert"), {
          margin: 0,
          background:"#e4e3e1",
          filename: "generated-pdf.pdf",
          image: { type: 'jpg', quality: 0.98 },
          html2canvas: { 
            useCORS: true,
            scale: 2,
            logging: false,
            backgroundColor: "#e4e3e1"
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', backgroundColor: "#e4e3e1" }
        });
      },
      async getScan() {
        let scan=await APIRequest.detail('scans',this.scan_id)
        this.scan={}
        this.scan=scan
  
        if(scan.measurements)
        {
          let measurements=scan.measurements.replace('."',',"')
          measurements=measurements.replace('."',',"')
          measurements=measurements.replace('."',',"')
          measurements=measurements.replace('."',',"')
          
      
          this.measurements=JSON.parse(measurements)
        }
        
        console.log('TEST')
  
        console.log(this.measurements)
        //import data from "/Users/Documents/workspace/test.json"
      },
      selectScan(id) {
        this.selectedScan=this.scan.id
        localStorage.senseye_b2b_selected_scan=this.scan.id
     
      },
      calculateSize()
      {
        console.log('TEST WIDTH 2')
        console.log(this.svgWidth/12)
        return ((this.svgWidth/12)/210)*100+'%'
      },
      async svgUrlToBase64() {
        let url='https://rhino.visages.com:8082/frames/custom-fit/client-'+this.order_item.scan.id+'-model-'+calculateModelName(order_item.glass.id)+'-size-'+this.order_item.size.toUpperCase()+'-frame_drop-lenses.svg'
        const response = await fetch(url);
        const svgText = await response.text();
        
        const base64 = btoa(unescape(encodeURIComponent(svgText)));

        console.log( `data:image/svg+xml;base64,${base64}`)


      },
      async getSvgSizeFromUrl(url) {
  const response = await fetch(url);
  const svgText = await response.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, "image/svg+xml");
  const svg = doc.documentElement;

  let width = svg.getAttribute("width");
  let height = svg.getAttribute("height");

  // Si width et height sont présents en px ou sans unité → terminé
  if (width && height && !width.endsWith('%') && !height.endsWith('%')) {
    return {
      width: parseFloat(width),
      height: parseFloat(height)
    };
  }

  // Sinon on se rabat sur le viewBox
  const viewBox = svg.getAttribute("viewBox");
  if (viewBox) {
    const [, , w, h] = viewBox.split(/[\s,]+/).map(Number);
    return { width: w, height: h };
  }

  // Si aucune info → impossible
  return null;
}
      
      
    },
    watch:{
      
    },
    
    async mounted()
    {
    
      this.loading=true
      
      await this.getScan()
      //await this.svgUrlToBase64()
      let url='https://rhino.visages.com:8082/frames/custom-fit/client-'+this.order_item.scan.id+'-model-Louis%20C-size-'+this.order_item.size.toUpperCase()+'-frame_drop-lenses.svg'
     
      this.loading=false
      let size=await this.getSvgSizeFromUrl(url)
      console.log('TEST WIDTH')
      console.log(size.width)
      this.svgWidth=size.width
      console.log(url)

      var testurl = await this.getUrl()

      this.b64image='data:image/png;base64,'+testurl
     
      
    }
  }
  </script>
  
  <style lang="scss" >
  @import '@core/scss/vue/libs/vue-good-table.scss';
  .report-footer
  {
    margin-top:46px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    width:100%;
  
  }
  .lens-centering
  {
    display:flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .lens-centering .center img
  {
    width:100%;
  }
  
  .lens-centering .left,
  .lens-centering .right
  {
    flex:1;
  }
  .lens-centering .right
  {
    text-align: right;
  }
  
  .trait
  {
    border-top:1px solid #000;
    margin-top:20px;
    padding-top:10px;
  }
  .scan-measures .left,
  .scan-measures .right
  {
   
    padding-right:20px;
    width:50%;
  }

  .scan-measures .right
  {
    padding-left:20px;
    padding-right:20px;
    width:50%;
  }
  .scan-measures
  {
    position:relative;
    z-index: 999;
    color:#000;
    margin-top:-40px;
    display:flex;
  }
  .scan-canvas-content .head-scan
  {
    width:100%;
    position: relative;
    top:30px;
    z-index: 999;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .scan-canvas-content .head-scan .legend 
  {
    padding:5px 10px;
    border-radius: 10px;
    font-family: "profont";
    color:#fff;
    background-color: #000;
  }
  .scan-canvas-content .head-scan .left,
  .scan-canvas-content .head-scan .right
  {
    text-align: center;
    width:33%;
  }
  .scan-canvas-content
  {
    width:60%;
    margin-left:20%;
  }
  #element-to-convert {
    padding:20px;
  }
  #element-to-convert,
  .report
  {
    height:100%;
    font-size:10px;
    background-color: #e4e3e1;
  }
  .header-report .title 
  {
    width:60%;
    font-size:50px;
    line-height:1.1;
  }
  .header-report
  {
    width:100%;
    display:flex;
  }
  .infos 
  {
    
    width:30%;
    display:flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    font-family: "profont";
  
  }
  .line-info
  {
    padding-bottom:10px;
    width:100%;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-content
  {
    padding-bottom:10px;
    padding-top:10px;
    width:100%;
    font-weight: 600;
    padding-left:20px;
    border-bottom:1px solid #000;
  }
  .content-value
  {
    padding-left:20px;
    flex:1;
    display:flex;
    justify-content: flex-start;
    align-items: center;
  }
  
  .col-info
  {
    flex:1;
    display:flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: flex-start;
  }
  .product-infos
  {
    
    margin-left:20px;
    flex:1;
    display:flex;
  }
  .line-info .value
  {
    width:50%;
  }
  .photo-product
  {
    width:17%;
  }
  .subtitle
  {
    font-size:18px;
    font-weight: 500;
  }
 .table-product
 {
  border-top:2px solid #000;
    border-bottom:2px solid #000;
  margin-top:20px;
  width:100%;
  display:flex;
  justify-content: space-between;
  align-items: stretch;
 }
 .scan-measures .value
 {
  float:right;
 }
.scan-measures .measure-line
{
  display:flex;
  align-items:center;
  gap:8px;
}
.scan-measures .measure-line .dots
{
  flex:1;
  border-bottom:1px dotted #000;
  height:1px;
}
.scan-measures .measure-line .value
{
  float:none;
  white-space: nowrap;
}
 .bg-report 
 {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:auto;
  z-index:1;
 }
 .content-report
 {
  position:relative;
  z-index:2;
 }
 .product-img img {
    width:100%;
    height:auto;

}
.product-img {
    position:relative;

}
  </style>
  